"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStartUploadMutation = exports.useLazyGetFileUrlQuery = exports.useCompleteUploadMutation = exports.fileApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.fileApi = (0, react_1.createApi)({
    reducerPath: "fileApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["files"],
    endpoints: function (builder) { return ({
        startUpload: builder.mutation({
            query: function (body) { return ({ url: "/v1/file/upload", method: "POST", body: body }); },
        }),
        completeUpload: builder.mutation({
            query: function (id) { return ({ url: "/v1/file/".concat(id, "/complete"), method: "POST" }); },
            invalidatesTags: ["files"],
        }),
        getFileUrl: builder.query({
            query: function (id) { return "/v1/file/".concat(id, "/url"); },
            // Signed links expire, so never serve a cached one.
            keepUnusedDataFor: 0,
        }),
        // Deletes the record only while it is still pending, so a completion whose response was lost keeps its file.
        discardPendingUpload: builder.mutation({
            query: function (id) { return ({ url: "/v1/file/".concat(id, "/pending"), method: "DELETE" }); },
            invalidatesTags: ["files"],
        }),
    }); },
});
exports.useCompleteUploadMutation = exports.fileApi.useCompleteUploadMutation, exports.useLazyGetFileUrlQuery = exports.fileApi.useLazyGetFileUrlQuery, exports.useStartUploadMutation = exports.fileApi.useStartUploadMutation;
